import { useState } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import FiltersSection from '../components/FiltersSection';
import {
  BreakDownofPremiumByPurchaseSurceChart,
  PromoCodeAliasBreakdownBySourceChart,
  UserRetentionForMultiplePointsChart,
  DailyLostPremiumUsersChart,
} from '../components/PaymentCharts';

const PaymentAnalysisPage = () => {
  const [dates, setDates] = useState<Date[]>([
    new Date(Date.now() - 30 * 24 * 3600 * 1000),
    new Date(),
  ]);
  const [cohortDates, setCohortDates] = useState<Date[]>([
    new Date(Date.now() - 30 * 6 * 24 * 3600 * 1000),
    new Date(),
  ]);

  return (
    <PageLayoutsContainer
      title={`Payment Analysis`}
      withoutRightPadding={false}
    >
      <div className="space-y-6 ">
        <FiltersSection
          dates={dates}
          setDates={(dates) => {
            setDates(dates);
            setCohortDates(dates);
          }}
          autoSelectDatesDirection="horizontal"
        />

        <div className="grid grid-cols-2  gap-4">
          <DailyLostPremiumUsersChart dates={cohortDates} />
          <BreakDownofPremiumByPurchaseSurceChart dates={dates} />
          <PromoCodeAliasBreakdownBySourceChart dates={dates} />
          <UserRetentionForMultiplePointsChart dates={cohortDates} />
        </div>
      </div>
    </PageLayoutsContainer>
  );
};

export default PaymentAnalysisPage;
